import request from '@/utils/request'

/**
 * 获取权限列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listBasePrivileges(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/basePrivilege.listBasePrivileges',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加权限
 * @param {Object} data 权限数据
 * @returns {Promise} Promise对象
 */
export function saveBasePrivilege(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/basePrivilege.saveBasePrivilege',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新权限
 * @param {Object} data 权限数据
 * @returns {Promise} Promise对象
 */
export function updateBasePrivilege(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/basePrivilege.updateBasePrivilege',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除权限
 * @param {Object} data 权限数据
 * @returns {Promise} Promise对象
 */
export function deleteBasePrivilege(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/basePrivilege.deleteBasePrivilege',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}